import React, { ReactNode } from 'react';
import cc from 'classnames';

import styles from './DashboardCard.module.css';

interface IDashboardCard {
  children: ReactNode,
  className?: string,
  fullHeight?: boolean,
}

const DashboardCard = ({ children, className, fullHeight }: IDashboardCard) => (
  <div className={cc(styles.container, className, { [styles.fullHeight]: fullHeight })}>
    {children}
  </div>
);

export default DashboardCard;
